import * as React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';

class PdpSharedRestrictedMaterialsLoaderComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = { Component: null };
    }
    componentDidMount() {
        import(
            /* webpackChunkName: "PdpSharedRestrictedMaterials" */
            './PdpSharedRestrictedMaterials'
        )
            .then(({ PdpSharedRestrictedMaterials: Component }) => this.setState({ Component }))
            .catch(() => {
                return null;
            });
    }
    render() {
        const { Component } = this.state;
        return Component ? <Component {...this.props} /> : null;
    }
}

PdpSharedRestrictedMaterialsLoaderComponent.propTypes = {
    theme: PropTypes.object,
    viewer: PropTypes.object.isRequired,
};

export const PdpSharedRestrictedMaterialsLoader = createFragmentContainer(
    PdpSharedRestrictedMaterialsLoaderComponent,
    {
        viewer: graphql`
            fragment PdpSharedRestrictedMaterialsLoader_viewer on Viewer {
                ...PdpSharedRestrictedMaterials_viewer
            }
        `,
    }
);
